var map = {
	"./locale/ar_EG.tsx": "./components/locale/ar_EG.tsx",
	"./locale/az_AZ.tsx": "./components/locale/az_AZ.tsx",
	"./locale/bg_BG.tsx": "./components/locale/bg_BG.tsx",
	"./locale/ca_ES.tsx": "./components/locale/ca_ES.tsx",
	"./locale/cs_CZ.tsx": "./components/locale/cs_CZ.tsx",
	"./locale/da_DK.tsx": "./components/locale/da_DK.tsx",
	"./locale/de_DE.tsx": "./components/locale/de_DE.tsx",
	"./locale/el_GR.tsx": "./components/locale/el_GR.tsx",
	"./locale/en_GB.tsx": "./components/locale/en_GB.tsx",
	"./locale/en_US.tsx": "./components/locale/en_US.tsx",
	"./locale/es_ES.tsx": "./components/locale/es_ES.tsx",
	"./locale/et_EE.tsx": "./components/locale/et_EE.tsx",
	"./locale/fa_IR.tsx": "./components/locale/fa_IR.tsx",
	"./locale/fi_FI.tsx": "./components/locale/fi_FI.tsx",
	"./locale/fr_BE.tsx": "./components/locale/fr_BE.tsx",
	"./locale/fr_FR.tsx": "./components/locale/fr_FR.tsx",
	"./locale/ga_IE.tsx": "./components/locale/ga_IE.tsx",
	"./locale/he_IL.tsx": "./components/locale/he_IL.tsx",
	"./locale/hi_IN.tsx": "./components/locale/hi_IN.tsx",
	"./locale/hr_HR.tsx": "./components/locale/hr_HR.tsx",
	"./locale/hu_HU.tsx": "./components/locale/hu_HU.tsx",
	"./locale/hy_AM.tsx": "./components/locale/hy_AM.tsx",
	"./locale/id_ID.tsx": "./components/locale/id_ID.tsx",
	"./locale/is_IS.tsx": "./components/locale/is_IS.tsx",
	"./locale/it_IT.tsx": "./components/locale/it_IT.tsx",
	"./locale/ja_JP.tsx": "./components/locale/ja_JP.tsx",
	"./locale/kn_IN.tsx": "./components/locale/kn_IN.tsx",
	"./locale/ko_KR.tsx": "./components/locale/ko_KR.tsx",
	"./locale/ku_IQ.tsx": "./components/locale/ku_IQ.tsx",
	"./locale/lv_LV.tsx": "./components/locale/lv_LV.tsx",
	"./locale/mk_MK.tsx": "./components/locale/mk_MK.tsx",
	"./locale/mn_MN.tsx": "./components/locale/mn_MN.tsx",
	"./locale/ms_MY.tsx": "./components/locale/ms_MY.tsx",
	"./locale/nb_NO.tsx": "./components/locale/nb_NO.tsx",
	"./locale/ne_NP.tsx": "./components/locale/ne_NP.tsx",
	"./locale/nl_BE.tsx": "./components/locale/nl_BE.tsx",
	"./locale/nl_NL.tsx": "./components/locale/nl_NL.tsx",
	"./locale/pl_PL.tsx": "./components/locale/pl_PL.tsx",
	"./locale/pt_BR.tsx": "./components/locale/pt_BR.tsx",
	"./locale/pt_PT.tsx": "./components/locale/pt_PT.tsx",
	"./locale/ro_RO.tsx": "./components/locale/ro_RO.tsx",
	"./locale/ru_RU.tsx": "./components/locale/ru_RU.tsx",
	"./locale/sk_SK.tsx": "./components/locale/sk_SK.tsx",
	"./locale/sl_SI.tsx": "./components/locale/sl_SI.tsx",
	"./locale/sr_RS.tsx": "./components/locale/sr_RS.tsx",
	"./locale/sv_SE.tsx": "./components/locale/sv_SE.tsx",
	"./locale/ta_IN.tsx": "./components/locale/ta_IN.tsx",
	"./locale/th_TH.tsx": "./components/locale/th_TH.tsx",
	"./locale/tr_TR.tsx": "./components/locale/tr_TR.tsx",
	"./locale/uk_UA.tsx": "./components/locale/uk_UA.tsx",
	"./locale/vi_VN.tsx": "./components/locale/vi_VN.tsx",
	"./locale/zh_CN.tsx": "./components/locale/zh_CN.tsx",
	"./locale/zh_TW.tsx": "./components/locale/zh_TW.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/locale\\/.+_.+\\.tsx$";